/* import __COLOCATED_TEMPLATE__ from './selected-category.hbs.js'; */
import { computed } from "@ember/object";
import { htmlSafe } from "@ember/template";
import { classNames } from "@ember-decorators/component";
import { categoryBadgeHTML } from "discourse/helpers/category-link";
import SelectedNameComponent from "select-kit/components/selected-name";
const SelectedCategory = dt7948.c(class SelectedCategory extends SelectedNameComponent {
  get badge() {
    return htmlSafe(categoryBadgeHTML(this.item, {
      allowUncategorized: true,
      link: false
    }));
  }
  static {
    dt7948.n(this.prototype, "badge", [computed("item")]);
  }
}, [classNames("selected-category")]);
export default SelectedCategory;